import { render, staticRenderFns } from "./discovery.vue?vue&type=template&id=0bc71b23&scoped=true&"
import script from "./discovery.vue?vue&type=script&lang=js&"
export * from "./discovery.vue?vue&type=script&lang=js&"
import style0 from "./discovery.vue?vue&type=style&index=0&id=0bc71b23&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc71b23",
  null
  
)

export default component.exports